export default __webpack_public_path__ + "static/media/minus.83427c5b.svg";